import { render } from "./ActiveCustomerCard.vue?vue&type=template&id=44affc11&scoped=true"
import script from "./ActiveCustomerCard.vue?vue&type=script&lang=js"
export * from "./ActiveCustomerCard.vue?vue&type=script&lang=js"

import "./ActiveCustomerCard.vue?vue&type=style&index=0&id=44affc11&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/www/releases/20260911022759/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44affc11"]])

export default __exports__